import CandidateVideo from '@components/CandidateVideo';
import { useInterviewSession } from '@hooks/interview/useInterviewSession';
import type { BaseComponentProps } from '@interfaces/selection';
import { useRemoteVideoTileState } from '@providers/RemoteVideoTileProvider';
import { useRosterState } from '@providers/RosterProvider';
import type { FC, PropsWithChildren } from 'react';
import { memo } from 'react';

const CandidateVideos: FC<PropsWithChildren<BaseComponentProps>> = (props) => {
  const { roster, attendees } = useRosterState();
  const { tiles, tileIdToAttendeeId } = useRemoteVideoTileState();
  const { getInterviewInfo } = useInterviewSession();

  const interviewees = tiles.filter((tileId) => {
    const attendee = roster[tileIdToAttendeeId[tileId]] || {};
    const type = attendees.find(
      (dto) => dto.key === attendee?.externalUserId,
    )?.type;
    return type === 'interviewee';
  });

  const getInterviewee = () => {
    const isNameBlind = getInterviewInfo()?.nameBlindYn === 'true';
    const rosterInterviewee = findInterviewees();
    const name =
      attendees.find((dto) => dto.key === rosterInterviewee?.externalUserId)
        ?.name || '';

    return {
      name: isNameBlind ? '블라인드' : name,
      attendeeId: rosterInterviewee.attendeeId || '',
    };
  };

  const findInterviewees = () => {
    const result: { attendeeId?: string; externalUserId?: string } = {};
    for (const key in roster) {
      if (roster.hasOwnProperty(key)) {
        const value = roster[key];
        const type = attendees.find(
          (dto) => dto.key === value?.externalUserId,
        )?.type;
        if (value.externalUserId && type === 'interviewee') {
          result['attendeeId'] = value.chimeAttendeeId;
          result['externalUserId'] = value.externalUserId;
        }
      }
    }
    return result;
  };

  const isInterviewee = !!findInterviewees()?.externalUserId;

  if (!isInterviewee) return null;

  return (
    <CandidateVideo
      {...props}
      key={interviewees[0]}
      tileId={interviewees[0]}
      {...getInterviewee()}
    />
  );
};

export default memo(CandidateVideos);
